import {createAction} from 'util/redux';
import {ThemeOptions} from '@material-ui/core';

export const globalThemeChangedAction = createAction<ThemeOptions | null>('GLOBAL_THEME_CHANGED');